import React from "react";

const StatsCards = ({ stats, variant = "desktop" }) => {
  if (variant === "mobile") {
    return (
      <div className="grid grid-cols-4 gap-4 text-center">
        <div>
          <div className="text-lg font-bold text-blue-600">
            {stats?.totalCorrect || 0}-{stats?.totalIncorrect || 0}
          </div>
          <div className="text-xs text-gray-500">Season</div>
        </div>
        <div>
          <div className="text-lg font-bold text-green-600">
            {stats?.lastWeekCorrect || 0}-{stats?.lastWeekIncorrect || 0}
          </div>
          <div className="text-xs text-gray-500">Last Week</div>
        </div>
        <div>
          <div className="text-lg font-bold text-orange-600">
            {stats?.picksRemaining || 0}
          </div>
          <div className="text-xs text-gray-500">Remaining</div>
        </div>
        <div>
          <div className="text-lg font-bold text-purple-600">
            {stats?.rank || "-"}
          </div>
          <div className="text-xs text-gray-500">Rank</div>
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
      <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm">
        <p className="text-xs text-gray-500 uppercase font-bold tracking-wider">
          Season Record
        </p>
        <p className="text-xl font-bold">
          {stats?.totalCorrect || 0}-{stats?.totalIncorrect || 0}
        </p>
        <p className="text-sm text-gray-500">
          {stats?.winPercentage ? `${stats.winPercentage}%` : "0.0%"}
        </p>
      </div>

      <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm">
        <p className="text-xs text-gray-500 uppercase font-bold tracking-wider">
          Last Week Record
        </p>
        <p className="text-xl font-bold">
          {stats?.lastWeekCorrect || 0}-{stats?.lastWeekIncorrect || 0}
        </p>
        <p className="text-sm text-gray-500">Week {stats?.lastWeek || "N/A"}</p>
      </div>

      <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm">
        <p className="text-xs text-gray-500 uppercase font-bold tracking-wider">
          Picks Remaining
        </p>
        <p className="text-xl font-bold">{stats?.picksRemaining || 0}</p>
        <p className="text-sm text-gray-500">
          Week {stats?.currentWeek || "N/A"}
        </p>
      </div>

      <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm">
        <p className="text-xs text-gray-500 uppercase font-bold tracking-wider">
          Leaderboard Rank
        </p>
        <p className="text-xl font-bold">{stats?.rank || "-"}</p>
        <p className="text-sm text-gray-500">
          Out of {stats?.totalUsers || 0} players
        </p>
      </div>
    </div>
  );
};

export default StatsCards;
